<script setup lang="ts">
import StatementPeriodHeader from '@/components/dashboard/statements/StatementPeriodHeader.vue'
import StatementTotalsCards from '@/components/dashboard/statements/StatementTotalsCards.vue'
import UpgradeInlineLink from '@/components/dashboard/ui/UpgradeInlineLink.vue'
import type { DonorFinancialYear } from '@/types/donorFinancialYear'

defineProps<{
  year: DonorFinancialYear
  showUpgradeGate?: boolean
}>()

const emit = defineEmits<{
  upgrade: []
}>()
</script>

<template>
  <div
    class="sa-statement-card"
    :class="{ 'sa-statement-card--with-footer': showUpgradeGate }"
  >
    <div class="sa-statement-card__body">
      <StatementPeriodHeader :period="year.period" />
      <StatementTotalsCards :financial-year="year" />
    </div>
    <div v-if="showUpgradeGate" class="sa-statement-card__footer">
      <UpgradeInlineLink
        :message="$t('Dashboard.Home.SummaryGateInline')"
        @upgrade="emit('upgrade')"
      />
    </div>
  </div>
</template>
